// extracted by mini-css-extract-plugin
module.exports = {"text":"uRtREwvrCdv88NU8uIClE"};